<template>
    <q-card class="producto-panel-form" style="max-width: 100vw; height: 90vh; display: flex; flex-direction: column;">
        <!-- Header mejorado -->
        <ProductoToolbar :title="title" :res="res" :producto="producto" v-close-popup />
        <div class="row no-wrap content-scrollable">
            <!-- Columna principal: Formulario -->
            <div class="col-12 col-md-8 q-pa-md scroll" style="max-height: 75vh; overflow-y: auto;">
                <!-- Sección: Imagen del producto -->
                <ProductoImg :images-path="imagesPath" :form="form" :parentProps="props" />
                <!-- Sección: Información del Producto -->
                <q-expansion-item default-opened icon="info" label="Información del Producto"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section>
                            <ProductosCommon v-model:empresa-id="form.empresa_id" v-model:alicuota-id="form.alicuota_id"
                                v-model:producto-id="form.producto_id" v-model:tipo-venta-id="form.tipo_venta_id"
                                v-model:ubicacion-id="form.ubicacion_id"
                                @update:empresa-id="validate($event, 'empresa_id')"
                                @update:alicuota-id="validate($event, 'alicuota_id')"
                                @update:producto-id="validate($event, 'producto_id')"
                                @update:tipo-venta-id="validate($event, 'tipo_venta_id')"
                                @update:ubicacion-id="validate($event, 'ubicacion_id')" :res="res" />
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Dimensiones y Cantidad -->
                <q-expansion-item default-opened icon="straighten" label="Dimensiones y Cantidad"
                    caption="Configure las medidas y cantidades del panel"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section>
                            <div class="row q-col-gutter-md">
                                <div class="col-12 col-sm-6 col-md-3">
                                    <GltnInputNumber name="Ancho" :model-value="ancho" hide-hint label="Ancho (m)"
                                        readonly @update:model-value="validate($event, 'ancho')"
                                        :errors="res.getErrors('ancho')">
                                        <template v-slot:prepend>
                                            <q-icon name="mdi-arrow-left-right" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                    <GltnInputNumber v-model.number="form.cantidad_piezas" label="Cantidad Piezas"
                                        @update:model-value="validate($event, 'cantidad_piezas')"
                                        :errors="res.getErrors('cantidad_piezas')" hide-hint>
                                        <template v-slot:prepend>
                                            <q-icon name="inventory_2" />
                                        </template>
                                        <template v-slot:append>
                                            <q-icon name="help_outline" size="18px" color="grey-6">
                                                <q-tooltip>Número de piezas/paneles a cotizar</q-tooltip>
                                            </q-icon>
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                    <GltnInputNumber v-model.number="form.largo_pieza" label="Largo pieza (m)"
                                        @update:model-value="validate($event, 'largo_pieza')"
                                        :errors="res.getErrors('largo_pieza')" hide-hint>
                                        <template v-slot:prepend>
                                            <q-icon name="mdi-arrow-up-down" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                    <GltnInput :model-value="cantidadFormatted" readonly label="Total m²" hide-hint
                                        filled bg-color="blue-1">
                                        <template v-slot:prepend>
                                            <q-icon name="calculate" color="primary" />
                                        </template>
                                    </GltnInput>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Configuración Overlap (Opcional) -->
                <q-expansion-item v-model="form.overlap" icon="layers"
                    :label="form.overlap ? 'Overlap Configurado' : 'Configurar Overlap'"
                    caption="Active si el panel requiere overlap"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden" switch-toggle-side>
                    <q-card flat bordered>
                        <q-card-section>
                            <div class="row q-col-gutter-md">
                                <div class="col-12 col-md-6">
                                    <GltnSelect v-model="form.overlap_direccion" :options="overlapOptions"
                                        label="Dirección del overlap" emit-value>
                                        <template v-slot:prepend>
                                            <q-icon name="swap_horiz" />
                                        </template>
                                    </GltnSelect>
                                </div>
                                <div class="col-12 col-md-6">
                                    <GltnInputNumber v-model.number="form.overlap_largo" label="Largo Overlap"
                                        suffix="mm">
                                        <template v-slot:prepend>
                                            <q-icon name="architecture" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Precio y Descuentos -->
                <q-expansion-item default-opened icon="payments" label="Precio y Descuentos"
                    caption="Configure descuentos comerciales y estratégicos"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section>
                            <div class="row q-col-gutter-md">
                                <div class="col-12 col-md-4">
                                    <GltnInputNumber name="Precio Unitario" :model-value="form.precio_unitario"
                                        hide-hint prefix="US$" label="Precio Unitario" readonly filled
                                        bg-color="green-1" @update:model-value="validate($event, 'precio_unitario')"
                                        :errors="res.getErrors('precio_unitario')">
                                        <template v-slot:prepend>
                                            <q-icon name="attach_money" color="positive" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-md-4">
                                    <GltnInputNumber v-model.number="form.descuento_comercial"
                                        label="Descuento comercial" suffix="%"
                                        @update:model-value="validate($event, 'descuento_comercial')"
                                        :errors="res.getErrors('descuento_comercial')">
                                        <template v-slot:prepend>
                                            <q-icon name="local_offer" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-md-4" v-if="canShowEstrategico">
                                    <GltnInputNumber v-model.number="form.descuento_estrategico"
                                        label="Descuento estratégico" suffix="%"
                                        @update:model-value="validate($event, 'descuento_estrategico')"
                                        :errors="res.getErrors('descuento_estrategico')">
                                        <template v-slot:prepend>
                                            <q-icon name="trending_down" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Observaciones -->
                <q-expansion-item icon="notes" label="Observaciones" caption="Agregue notas adicionales (opcional)"
                    header-class="bg-grey-2 text-primary text-weight-medium" class="rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section>
                            <GltnInput v-model="form.observaciones" label="Observaciones" type="textarea" rows="3"
                                hint="Información adicional sobre este panel">
                                <template v-slot:prepend>
                                    <q-icon name="comment" />
                                </template>
                            </GltnInput>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
            </div>

            <!-- Columna lateral: Resumen -->
            <ProductoResumen
                type="panel"
                :form="form"
                :producto="producto"
                :ancho="ancho"
                :validation-progress="validationProgress"
                :validation-progress-text="validationProgressText"
            >
                <template #after-card>
                    <ProductoResumenTips>
                        <li>Presiona <kbd>Ctrl + S</kbd> para guardar rápido</li>
                        <li>Los campos marcados con <q-icon name="error" size="14px" color="warning" /> son requeridos</li>
                        <li>El overlap es opcional para este producto</li>
                    </ProductoResumenTips>
                </template>
            </ProductoResumen>
        </div>

        <q-separator />

        <!-- Footer con acciones -->
        <q-card-actions class="q-pa-md actions-fixed">
            <div class="row full-width q-gutter-sm">
                <div class="col">
                    <q-btn outline label="Cancelar" color="grey-7" icon="close" v-close-popup class="full-width" />
                </div>
                <div class="col" v-if="props.oper !== 'view'">
                    <q-btn unelevated :label="props.oper === 'add' ? 'Agregar al carrito' : 'Actualizar'"
                        :color="res.valid ? 'primary' : 'grey'"
                        :icon="props.oper === 'add' ? 'add_shopping_cart' : 'save'" @click="cartSave"
                        :disable="!res.valid" :loading="loading" class="full-width">
                        <template v-slot:loading>
                            <q-spinner-hourglass size="20px" />
                        </template>
                    </q-btn>
                </div>
            </div>
        </q-card-actions>
    </q-card>
</template>

<script setup>

import { computed, reactive, ref, onMounted, onUnmounted } from "vue";
import { round } from "mathjs";
import { useCartStore } from "@/stores/useCartStore.js";
import { usePage } from "@inertiajs/vue3";
import { usePrecioCalc } from "@/composables/usePrecioCalc";
import GltnInput from "@/components/form/GltnInput.vue";
import GltnInputNumber from "@/components/form/GltnInputNumber.vue";
import GltnSelect from "@/components/form/GltnSelect.vue";
import ProductoImg from "./components/ProductoImg.vue";
import ProductoResumen from "../ProductoResumen.vue";
import ProductoResumenTips from "../ProductoResumenTips.vue";
import ProductosCommon from "./components/ProductosCommon.vue";
import ProductoToolbar from "./components/ProductoToolbar.vue";
import suite from "./ProductoPanelValidation.js";
import { useProductoTitle } from "@/composables/useProductoTitle.js";

const page = usePage();
const imagesPath = page.props.productosImagesPath;
const canShowEstrategico = computed(() => page.props?.auth?.can.includes('presupuesto.item.estrategico'));

const props = defineProps({
    oper: String,
    producto: Object,
    formulario: Object,
    presupId: Number,
    isSavedPresup: {
        type: Boolean,
        default: false,
    },
});

const emits = defineEmits(["added", "updated"]);

const overlapOptions = [
    { label: "Adelante", value: "adelante" },
    { label: "Atras", value: "atras" },
    { label: "Sin Confirmar", value: "sinConfirmar" },
];

const form = reactive({
    alicuota_id: 3,
    ubicacion_id: "",
    ancho: round(Number.parseFloat(props.producto.ancho), 2),
    cantidad: "",
    cantidad_piezas: "",
    descuento_comercial: 0,
    descuento_estrategico: 0,
    descuento_monto: 0,
    empresa_id: "",
    largo_pieza: "",
    overlap: false,
    overlap_direccion: "sinConfirmar",
    overlap_largo: 0,
    precio_unitario: round(Number.parseFloat(props.producto.precio), 2),
    tipo_venta_id: "",
    total: "",
    id: "",
    observaciones: "",
});

const ancho = computed(() => {
    return round(form.ancho, 2);
});

const setValues = () => {
    for (const key in props.formulario) {
        form[key] = props.formulario[key];
    }
};

// TITULO
const title = useProductoTitle(props.oper, 'panel');

// VALIDACION
const res = ref();
res.value = suite.get();
const validate = (value, name) => {
    res.value = suite(name, form);
};

// Progress de validación
const validationProgress = computed(() => {
    const requiredFields = ['empresa_id', 'alicuota_id', 'producto_id', 'tipo_venta_id', 'cantidad_piezas', 'largo_pieza', 'ubicacion_id'];
    const completed = requiredFields.filter(field => {
        const value = form[field];
        return value !== '' && value !== null && value !== undefined;
    }).length;
    return completed / requiredFields.length;
});

const validationProgressText = computed(() => {
    const percent = Math.round(validationProgress.value * 100);
    return `Formulario ${percent}% completo`;
});

onMounted(() => {
    if (props.oper === "edit" || props.oper === 'view') {
        setValues();
    }
    validate();

    // Agregar keyboard shortcut para guardar (Ctrl+S)
    document.addEventListener('keydown', handleKeyboardShortcut);
});

onUnmounted(() => {
    // Limpiar evento
    document.removeEventListener('keydown', handleKeyboardShortcut);
});

const handleKeyboardShortcut = (e) => {
    // Ctrl + S o Cmd + S para guardar
    if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault();
        if (res.value.valid) {
            cartSave();
        }
    }
};

const {
    cantidad,
    cantidadFormatted,
    precio_unitario,
    subtotal,
    total,
    totalFormatted,
    descuento_comercial,
    descuento_estrategico,
} = usePrecioCalc(form);

// GESTION DE CART
const cartStore = useCartStore();
const loading = computed(() => cartStore.getLoadingStatus);
const cartSave = () => {
    if (props.oper === "add") {
        cartAdd();
    } else {
        cartUpdate();
    }
};

const cartUpdate = async () => {
    await cartStore.itemUpdate(
        {
            form: { ...form },
            producto: { ...props.producto },
        },
        props.isSavedPresup,
        props.presupId
    );
    emits("updated");
};

const cartAdd = async () => {
    await cartStore.itemAdd(
        {
            form: { ...form },
            producto: { ...props.producto },
        },
        props.isSavedPresup,
        props.presupId
    );
    emits("added");
};

</script>

<style lang="scss" scoped>
@use 'sass:color';
.producto-panel-form {
    border-radius: 16px;
    overflow: hidden;

    // Gradiente para el header
    .bg-gradient-primary {
        background: linear-gradient(135deg, var(--q-primary) 0%, color.adjust(#1976d2, $lightness: -10%) 100%);
    }

    // Sección de imagen
    &__image-section {
        border-radius: 12px;
        overflow: hidden;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
    }

    // Scrollbar personalizado
    ::-webkit-scrollbar {
        width: 8px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;

        &:hover {
            background: #555;
        }
    }

}

// Responsive
@media (max-width: 1023px) {
    .producto-panel-form {
        border-radius: 0;
    }
}

// Expansion items
:deep(.q-expansion-item) {
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &.q-expansion-item--expanded {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .q-expansion-item__container {
        .q-item {
            min-height: 56px;
        }
    }
}

// Estados de los inputs
:deep(.q-field) {
    &.q-field--readonly {
        .q-field__control {
            opacity: 0.8;
        }
    }

    &.q-field--error {
        .q-field__control {
            animation: shake 0.4s ease-in-out;
        }
    }
}

@keyframes shake {
    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    75% {
        transform: translateX(5px);
    }
}

// Mejora de tipografía
.text-white-7 {
    color: rgba(255, 255, 255, 0.7);
}

// Spacing utilities adicionales
.q-gutter-md>* {
    margin-bottom: 16px !important;
}
</style>
